const isPlainObject = value => Object.prototype.toString.call(value) === '[object Object]';

const cloneValue = value => {
    if (Array.isArray(value)) {
        return value.map(cloneValue);
    }

    if (isPlainObject(value)) {
        return Object.keys(value).reduce((copy, key) => {
            copy[key] = cloneValue(value[key]);
            return copy;
        }, {});
    }

    return value;
};

const normalizeEmptyValue = value => {
    if (typeof value === 'undefined') {
        return null;
    }

    if (Array.isArray(value)) {
        return value.map(normalizeEmptyValue);
    }

    if (isPlainObject(value)) {
        return Object.keys(value).reduce((copy, key) => {
            copy[key] = normalizeEmptyValue(value[key]);
            return copy;
        }, {});
    }

    return value;
};

const applyPatch = (value, patchOrUpdater) => {
    const copy = normalizeEmptyValue(cloneValue(value || {}));

    if (typeof patchOrUpdater === 'function') {
        const nextValue = patchOrUpdater(copy);
        return normalizeEmptyValue(typeof nextValue === 'undefined' ? copy : nextValue);
    }

    return normalizeEmptyValue({
        ...copy,
        ...(patchOrUpdater || {})
    });
};

const updateRootValue = (model, patchOrUpdater) => {
    const root = model.getRoot();
    const nextValue = applyPatch(root.getValue ? root.getValue() : root.value, patchOrUpdater);
    model.setValue(root, nextValue);
    return nextValue;
};

const updateCellValue = (model, cell, patchOrUpdater) => {
    const nextValue = applyPatch(cell.getValue ? cell.getValue() : cell.value, patchOrUpdater);
    model.setValue(cell, nextValue);
    return nextValue;
};

const bindInputChange = ({element, model, cell, name, value = event => event.target.value, root = false}) => {
    element.addEventListener('change', event => {
        const patch = {[name]: value(event)};
        if (root) {
            updateRootValue(model, patch);
        } else {
            updateCellValue(model, cell, patch);
        }
    });
    return element;
};

export {
    applyPatch,
    bindInputChange,
    cloneValue,
    normalizeEmptyValue,
    updateCellValue,
    updateRootValue
};
